import { Routes, Route, Navigate } from 'react-router';
import ConventionPage from './pages/Convention';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/convention" replace />} />
      <Route path="/convention" element={<ConventionPage />} />
    </Routes>
  );
}
